export const IS_ANDROID = /android/i.test(navigator.userAgent);

export const IS_IOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(self).MSStream;

// @see https://developer.chrome.com/multidevice/user-agent
export const IS_IOS_CHROME = IS_IOS && /CriOS\//.test(navigator.userAgent);
export const IS_IOS_SAFARI = IS_IOS && /Safari\//.test(navigator.userAgent);